import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=2e0598f8&"
import script from "./GroupView.vue?vue&type=script&lang=js&"
export * from "./GroupView.vue?vue&type=script&lang=js&"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=2e0598f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports